import { RootState } from "../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.updatePositionColumn.loading;
export const selectErrorMessage = (state: RootState) =>
  state.updatePositionColumn.error;
export const updatePositionColumnDataResponse = (state: RootState) =>
  state.updatePositionColumn.updatePositionColumnResponse;
